import { getResponseErrorStatusCode } from '../../../utils/get-response-error-status-code';
import { getAddGiftCardErrorV1 } from './errors/add-gift-card-error';
import { getAddTicketRedemptionCardErrorV1 } from './errors/add-ticket-redemption-card-error';
import { getAddVoucherErrorV1 } from './errors/add-voucher-error';
import { getGetPrintStreamsErrorV1 } from './errors/get-print-streams-error';
import { getRemoveVoucherErrorV1 } from './errors/remove-voucher-error';
import { getSetOrderAsCollectedErrorV1 } from './errors/set-order-as-collected-error';
import { getSetShowtimeErrorV1 } from './errors/set-showtime-error';
import { getSetSubscriptionErrorV1 } from './errors/set-subscription-error';
import { getStartOrderPreparationErrorV1 } from './errors/start-order-preparation-error';
import { getSwapSeatsErrorV1 } from './errors/swap-seats-error';
import { ordersApiRoutes as routes } from './routes';
import { orderCompletionPollingPredicate, orderPaymentStatusPollingConfiguration } from './utils/order-polling-predicates';
export function getOrdersApiV1(httpClient) {
    return {
        cancel: (orderId)=>httpClient.delete(routes.cancel(orderId))
        ,
        getById: (orderId)=>httpClient.get(routes.getById(orderId))
        ,
        resetExpiry: (orderId)=>httpClient.post(routes.resetExpiry(orderId), {})
        ,
        completed: {
            getById: (orderId)=>httpClient.get(routes.completed.getById(orderId))
            ,
            swapSeats: (orderId, showtimeId, request)=>httpClient.put(routes.completed.swapSeats(orderId, showtimeId), request).catch(async (e)=>{
                    throw await getSwapSeatsErrorV1(e);
                })
            ,
            getIdentifiersForJourneyReference: (journeyReference)=>httpClient.get(routes.completed.getIdentifiersForJourneyReference(journeyReference))
            ,
            startOrderPreparation: (orderId)=>httpClient.post(routes.completed.startOrderPreparation(orderId), undefined).catch(async (e)=>{
                    throw await getStartOrderPreparationErrorV1(e);
                })
            ,
            getPrintStreams: (orderId, query)=>httpClient.get(routes.completed.getPrintStreams(orderId), {
                    queryParams: query
                }).catch(async (e)=>{
                    throw await getGetPrintStreamsErrorV1(e);
                })
            ,
            setAsCollected: (orderId)=>httpClient.put(routes.completed.setAsCollected(orderId), undefined).catch(async (e)=>{
                    throw await getSetOrderAsCollectedErrorV1(e);
                })
        },
        completion: {
            create: (orderId)=>httpClient.post(routes.completion.create(orderId), undefined)
            ,
            get: (orderId)=>httpClient.get(routes.completion.get(orderId), {
                    pollingConfiguration: {
                        predicate: orderCompletionPollingPredicate,
                        exponentialWaitTime: true
                    }
                }).catch((error)=>{
                    if (getResponseErrorStatusCode(error) === 404) return undefined;
                    throw error;
                })
        },
        create: {
            standard: (standardOrder)=>httpClient.post(routes.create.standard(), standardOrder)
            ,
            giftShop: ()=>httpClient.post(routes.create.giftShop(), undefined)
            ,
            subscription: ()=>httpClient.post(routes.create.subscription(), undefined)
        },
        customer: {
            get: (orderId)=>httpClient.get(routes.customer.get(orderId))
            ,
            set: (orderId, customer)=>httpClient.put(routes.customer.set(orderId), customer)
        },
        items: {
            set: (orderId, request)=>httpClient.put(routes.items.set(orderId), request)
        },
        payments: {
            remove: (orderId, paymentId)=>httpClient.delete(routes.payments.remove(orderId, paymentId))
            ,
            embedded: {
                create: (orderId, embeddedPaymentCreate)=>httpClient.post(routes.payments.embedded.create(orderId), embeddedPaymentCreate)
                ,
                getCurrent: (orderId)=>httpClient.get(routes.payments.embedded.getCurrent(orderId), {
                        pollingConfiguration: orderPaymentStatusPollingConfiguration
                    })
            },
            giftCard: {
                add: (orderId, giftCardPayment)=>httpClient.post(routes.payments.giftCard.add(orderId), giftCardPayment).catch(async (e)=>{
                        throw await getAddGiftCardErrorV1(e);
                    })
            },
            redirect: {
                create: (orderId, redirectPaymentCreate)=>httpClient.post(routes.payments.redirect.create(orderId), redirectPaymentCreate)
                ,
                getCurrent: (orderId, pollForCompletionStatus)=>httpClient.get(routes.payments.redirect.getCurrent(orderId), {
                        pollingConfiguration: pollForCompletionStatus ? orderPaymentStatusPollingConfiguration : undefined
                    }).catch((error)=>{
                        if (getResponseErrorStatusCode(error) === 404) return undefined;
                        throw error;
                    })
            },
            cinemaProcessed: {
                create: (orderId)=>httpClient.post(routes.payments.cinemaProcessed.create(orderId), undefined)
                ,
                complete: (orderId, request)=>httpClient.put(routes.payments.cinemaProcessed.complete(orderId), request)
            },
            memberBalance: {
                getMaximum: (orderId)=>httpClient.get(routes.payments.memberBalance.getMaximum(orderId))
                ,
                set: (orderId, request)=>httpClient.put(routes.payments.memberBalance.set(orderId), request)
            }
        },
        showtimes: {
            set: (orderId, showtimeId, request)=>httpClient.put(routes.showtimes.set(orderId, showtimeId), request).catch(async (e)=>{
                    throw await getSetShowtimeErrorV1(e);
                })
        },
        subscriptions: {
            set: (orderId, request)=>httpClient.put(routes.subscriptions.set(orderId), request).catch(async (e)=>{
                    throw await getSetSubscriptionErrorV1(e);
                })
        },
        ticketRedemptionCards: {
            add: (orderId, orderTicketRedemptionCardRequest)=>httpClient.post(routes.ticketRedemptionCards.add(orderId), orderTicketRedemptionCardRequest).catch(async (e)=>{
                    throw await getAddTicketRedemptionCardErrorV1(e);
                })
        },
        vouchers: {
            add: (orderId, orderVoucherRequest)=>httpClient.post(routes.vouchers.add(orderId), orderVoucherRequest).catch(async (e)=>{
                    throw await getAddVoucherErrorV1(e);
                })
            ,
            remove: (orderId, voucherId)=>httpClient.delete(routes.vouchers.remove(orderId, voucherId)).catch(async (e)=>{
                    throw await getRemoveVoucherErrorV1(e);
                })
        }
    };
}

//# sourceMappingURL=get-orders-api.js.map